module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-BoldItalic-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-BoldItalic-webfont.svg
// module id = 1621
// module chunks = 0